import React, { useState, useEffect } from 'react';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Post from '../../../../utils/Post';
import BloquesSeccion from './componentes/BloquesSeccion';
import FloresCatalogo from './componentes/FloresCatalogo';
import VariedadesCatalogo from './componentes/VariedadesCatalogo';
import ColoresCatalogo from './componentes/ColoresCatalogo';
import { get } from 'lodash';

const CatalogoFloresVariedadColores = () => {
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [section, setsection] = useState('tipos_flor');
    const [datosFlor, setdatosFlor] = useState({ tipos_flor: [], flores: [], variedades: [], colores: [] });
    const menus = [
        { key: 'tipos_flor', name: 'BLOQUES' },
        { key: 'flores', name: 'FLORES' },
        { key: 'variedades', name: 'VARIEDADES' },
        { key: 'colores', name: 'COLORES' }
    ];
    useEffect(() => {
        getAPIdata();
    }, []);
    const getAPIdata = async (uri = 'catalogos/flores/get', data = {}, allResp = false) => {
        setloader(true);
        let resp = await Post(uri, data);
        setloader(false);
        if (allResp) return resp;
        if (resp.estatus) setdatosFlor(resp.data);
        return resp.estatus;
    }

    const area_button = (menu) => {
        return (
            <div className='bw-150 mt-1' key={menu.key + " menu"}>
                <button className={'btn btn-sm round-m w-100 border ' + (section == menu.key ? "btn-warning text-bold" : "btn-light shadow border-warning scale-025")}
                    onClick={() => setsection(menu.key)}>
                    {menu.name}
                    <span className='text-xs ms-2 text-blue4 text-500'>{`${datosFlor[menu.key].length}`}</span>
                </button>
            </div>
        )
    }

    const elimnarNoAsociados = async (tipo) => {
        setdialog({
            tipo: "error",
            show: true,
            title: "CONFIRME PARA CONTINUAR",
            body: "¿Realmente desea eliminar los elementos no asociados?",
            respYes: "Si, eliminar",
            respNot: "Cancelar",
            funct: (resp) => { if (resp) eliminarNA(tipo); setdialog({ show: false }) },
            size: 'm'
        });

    }

    const eliminarNA = async (tipo) => {
        if (await getAPIdata('catalogos/flores/eliminarNoAsociados', { tipo: tipo })) {
            let sel = section + "";
            setsection("");
            setTimeout(() => {
                setsection(sel);
            }, 200);
        }
    }



    return (
        <div className='w-100 overflow bg-white m-0 p-1 overflow relative border round-m shadow-sm dosis' style={{ height: "calc(100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 p-1 bg-orange-900 ps-2 text-white text-xl shadow round-top-m' style={{ position: "sticky", top: 0, left: 0, zIndex: 2 }}>Catálogo de flores</div>
                {menus.map((menu) => area_button(menu))}
                {section === "colores" && <ColoresCatalogo data={datosFlor.colores} show={section === "colores"} setdatosFlor={setdatosFlor}
                    elimnarNoAsociados={elimnarNoAsociados} />}
                {section === "variedades" && <VariedadesCatalogo data={datosFlor.variedades} show={section === "variedades"} setdatosFlor={setdatosFlor}
                    elimnarNoAsociados={elimnarNoAsociados} />}
                {section === "flores" && <FloresCatalogo data={datosFlor.flores} show={section === "flores"} setdatosFlor={setdatosFlor}
                    elimnarNoAsociados={elimnarNoAsociados} />}
                {section === "tipos_flor" &&
                    <BloquesSeccion
                        data={datosFlor.tipos_flor} show={section === "tipos_flor"}
                        opciones={{ flores: datosFlor.flores, variedades: datosFlor.variedades, colores: datosFlor.colores }}
                        setdatosFlor={setdatosFlor} elimnarNoAsociados={elimnarNoAsociados} />

                }
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default CatalogoFloresVariedadColores;